import { Page } from "modules/Page";

import "./bundle-page.scss";

export class BundlePage extends Page<typeof BundlePage> {
    static readonly className = "js-bundle-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);
        this.slidePackages();
        this.bindSlideButtons();
        this.handleHashNavigation();
    }

    handleHashNavigation() {
        const param = window.location.hash;
        const slide1 = "bundle__slide--1";
        const slide2 = "bundle__slide--2";
        const slide3 = "bundle__slide--3";

        if (param === `#${slide1}`) this.hideBodySlide(slide1, [slide2, slide3]);
        if (param === `#${slide2}`) this.hideBodySlide(slide2, [slide1, slide3]);
        if (param === `#${slide3}`) this.hideBodySlide(slide3, [slide1, slide2]);
    }

    hideBodySlide(showId: string | undefined, hideIds: string[]) {
        const showDiv = this.rootElement.querySelector(`#${showId}`);

        if (showDiv) {
            const showBody = showDiv.querySelector(".bundle__slide--body");
            showBody?.classList.add("bundle_visible");
            showBody?.classList.remove("bundle_hide");
        }

        hideIds.forEach(hideId => {
            const hideDiv = this.rootElement.querySelector(`#${hideId}`);
            if (hideDiv) {
                const hideBody = hideDiv.querySelector(".bundle__slide--body");
                hideBody?.classList.add("bundle_hide");
                hideBody?.classList.remove("bundle_visible");
            }
        });
    }

    bindSlideButtons() {
        this.rootElement.querySelectorAll<HTMLButtonElement>("[data-show-slide]").forEach(button => {
            button.addEventListener("click", () => {
                const showId = button.dataset.showSlide;
                const hideIds = button.dataset.hideSlides?.split(",") || [];
                this.hideBodySlide(showId, hideIds);
            });
        });
    }

    slidePackages() {
        const slider = this.rootElement.querySelector<HTMLDivElement>(".js-bundle-slider");
        if (!slider) return;

        const slidePrev = slider.querySelectorAll(".js-bundle-prev");
        const slideNext = slider.querySelectorAll(".js-bundle-next");

        slidePrev.forEach(prevButton => {
            prevButton.addEventListener("click", () => {
                const sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider-index"));
                slider.style.setProperty("--slider-index", (sliderIndex - 1).toString());
            });
        });

        slideNext.forEach(nextButton => {
            nextButton.addEventListener("click", () => {
                const sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider-index"));
                slider.style.setProperty("--slider-index", (sliderIndex + 1).toString());
            });
        });
    }
}